import Label from './label';
import Basic from './basic';
import Striped from './striped';
const Progress = { Label, Basic, Striped };
export default Progress;
